<template>
    <div>
        <p v-if="getChangedStore1 && (ltype=='1')">{{readFromStore()}}</p>
        <p v-if="getChangedStore2 && (ltype=='2')">{{readFromStore()}}</p>
        <p v-if="getRefresh1 && (ltype=='1')">{{refreshData()}}</p>
        <p v-if="getRefresh2 && (ltype=='2')">{{refreshData()}}</p>

        <p v-if="getSaveBeforeDelete1 || getSaveBeforeDelete2">{{saveBeforeOperation()}}</p>

        <p v-if="getAddElement && !getRefresh1 && !getRefresh2">{{addRule()}}</p>
        <p v-if="getDeleteElement > -1 && getCanDelete1 && getCanDelete2">{{deleteRule()}}</p>      
        
        <div>
            <v-flex xs12>
                <v-text-field
                    v-model="mycontent.title"
                    label="Title:"
                ></v-text-field>  
            </v-flex>    

            <div>
                    <div>
                        <v-toolbar dense @click="$store.commit('changeCollapse',0)">
                        <v-app-bar-nav-icon></v-app-bar-nav-icon>
                             <v-toolbar-title>Assignment ({{mycontent.assignment.length}} chars)</v-toolbar-title>
                        </v-toolbar>
                        <div v-if="getCollapses.a">
                            <v-flex xs12 >
                                <quill-editor v-model='mycontent.assignment' :options="getEditorOption()">
                                </quill-editor>
                            </v-flex>
                            <v-flex xs12 justify-end>
                                <v-btn @click="showHtmlC">Show HTML</v-btn>
                                <v-btn v-if="showedHtmlC" @click="updateC">Update</v-btn>
                            </v-flex>
                            <v-textarea v-if="showedHtmlC" v-model=HtmlContent>
                            </v-textarea>
                        </div>
                    </div>

                    <div>
                        <v-toolbar dense @click="$store.commit('changeCollapse',1)">
                        <v-app-bar-nav-icon></v-app-bar-nav-icon>
                             <v-toolbar-title>Requested file: ({{mycontent.requestedFile.length}} chars)</v-toolbar-title>
                        </v-toolbar>
                        <div v-if="getCollapses.b">
                            <codemirror class="border-top" ref="myCm" v-model="mycontent.requestedFile" 
                                :options="cmOptions"
                                >
                            </codemirror>
                        </div>
                    </div>

                    <div>
                        <v-toolbar dense @click="$store.commit('changeCollapse',2)">
                        <v-app-bar-nav-icon></v-app-bar-nav-icon>
                            <v-toolbar-title>Author's solution ({{mycontent.authorsFile.length}} chars)</v-toolbar-title>
                        </v-toolbar>    
                            
                        <v-toolbar dense>
                            <v-spacer></v-spacer>
                            <v-btn outlined style="magrin-right:50px;">{{grade}}%</v-btn>
                            <v-icon @click="showExecuteInfo = !showExecuteInfo" :color="getResultColor()" large style="magrin-right:10px;">reorder</v-icon>
                            <v-icon @click="checkCode()" color="green" large style="magrin-right:5px;">check_circle_outline</v-icon>


                        </v-toolbar>
                        <v-card v-if="showExecuteInfo" color="lime lighten-5">
                            <v-card-text>
                                <p v-for="(rule, index) in executionResult" :key="index">
                                    <v-icon v-if="rule.res" color="green">check_circle</v-icon>
                                    <v-icon v-if="!rule.res"  color="red">error</v-icon>                                
                                    {{rule.desc}} </p>
                            </v-card-text>     
                        </v-card>

                        <div v-if="getCollapses.c">
                            <codemirror class="border-top" ref="myCm" v-model="mycontent.authorsFile" 
                                :options="cmOptions"
                                >
                            </codemirror>
                        </div>
                    </div>
                                        
                    <div>
                        <v-toolbar dense @click="$store.commit('changeCollapse',3)">
                        <v-app-bar-nav-icon></v-app-bar-nav-icon>
                             <v-toolbar-title>Help ({{mycontent.help.length}} chars)</v-toolbar-title>
                        </v-toolbar>
                        <div v-if="getCollapses.d">
                            <v-flex xs12 >
                                <quill-editor v-model="mycontent.help" :options="getEditorOption()">
                                </quill-editor>
                            </v-flex>
                            <v-flex xs12 justify-end>
                                <v-btn @click="showHtmlH">Show HTML</v-btn>
                                <v-btn v-if="showedHtmlH" @click="updateH">Update</v-btn>
                            </v-flex>
                            <v-textarea v-if="showedHtmlH" v-model=HtmlContent>
                            </v-textarea>
                        </div>
                    </div>

                    <div>
                        <v-toolbar dense @click="$store.commit('changeCollapse',4)">
                        <v-app-bar-nav-icon></v-app-bar-nav-icon>
                                <v-toolbar-title>Rules ({{mycontent.rules_list.length}} rule(s))</v-toolbar-title>
                        </v-toolbar>            
                        <div v-if="getCollapses.e">
                            <v-layout row wrap v-if="getHTMLSystemRules && ltype == '1'">
                                <p v-if="!rulesListLang">{{prepareRules()}}</p>
                                <v-flex v-if="rulesListLang" xs12 >
                                    <v-menu
                                        transition="slide-y-transition"
                                        bottom
                                        right
                                        >
                                        <template v-slot:activator="{ on }">
                                            <v-btn fluid style="margin: 0px; padding: 0px; width: 100%"
                                                small
                                                color="primary"
                                                justify-left
                                                v-on="on"
                                            >
                                             Select rule
                                             <v-spacer></v-spacer>
                                             <v-icon large>arrow_drop_down</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-list>
                                            <v-list-item
                                                v-for="(item, index) in rulesListLang"
                                                :key="index"
                                                @click="changeRuleIndex(index)"                                                
                                            >
                                            <v-list-item-title>{{ item.text }}</v-list-item-title>
                                            </v-list-item>
                                        </v-list>  
                                    </v-menu>
                                </v-flex>

                                <v-flex xs11 v-if="rulesListLang && ruleSelectedIndex>-1">
                                   <p> {{rulesListLang[ruleSelectedIndex].text}} </p>
                                </v-flex>
                                <v-flex xs1 v-if="ruleSelectedIndex>-1">
                                    <v-layout justify-center>
                                        <v-icon @click="addRule">mdi-plus-circle-outline</v-icon>
                                    </v-layout>
                                </v-flex>
                            </v-layout>                            
                            <v-layout row wrap v-if=" ltype == '2'">
                                <p v-if="!rulesListLang">{{prepareRules()}}</p>
                                <v-btn fluid style="margin: 0px; padding: 0px; width: 100%"
                                                small
                                                color="primary"
                                                justify-left
                                                disabled
                                            >
                                             Select rule in primary language panel
                                            </v-btn>
                                <p v-if="getRuleIndex && rulesListLang && getRuleIndex > -1">{{rulesListLang[getRuleIndex].text}}
                                </p>
                            </v-layout>
<v-layout row wrap v-if="rulesGlobals">
                                <v-flex xs12>
                                <v-card v-for="(rule, index) in mycontent.rules_list" :key="index">
                                    <v-card-text>
                                        <v-layout row wrap>
                                            <v-flex xs1 v-if="ltype == '1'">
                                                <v-layout justify-center>
                                                    <v-icon @click="deleteRuleEvent(index)">mdi-minus-circle-outline</v-icon>
                                                </v-layout>
                                                {{rule.rule_id}}:
                                            </v-flex>
                                            <v-flex xs11>
                                                <v-text-field
                                                    v-model="rule.description"
                                                    label="Description for user" 
                                                ></v-text-field>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout>
                                            <v-flex xs12>
                                            <span v-for="(content, index_inside) in rule.content" :key="index_inside">
                                            <span v-if="content.type=='c'">{{content.text}}</span>
                                            <span v-if="content.type=='t'">
                                                <v-chip>
                                                    <input type = "text" v-model = "content.text" :size = "content.text.length">
                                                </v-chip>
                                            </span>
                                            <span v-if="content.type=='n'">
                                                <v-chip color="yellow">
                                                    <input type="text" v-model = "content.text" v-on:keypress="isNumber($event)" :size = "content.text.length">
                                                </v-chip>
                                            </span>
                                            </span>
                                            </v-flex>
                                        </v-layout>
                                    </v-card-text>
                                </v-card>
                                </v-flex>     
                            </v-layout>
                        </div>

                    </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import { codemirror } from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'
import { quillEditor } from 'vue-quill-editor'
import * as check_rules from '../../assets/check_rules.js'

export default {
    data() {
        return {
                showExecuteInfo: false,
                executionInfo: '',
                executionResult: [],
                grade: 0,
                cmOptions: {
                    tabSize: 4,
                    styleActiveLine: true,
                    lineNumbers: true,
                    line: true,
                    mode: 'text/html',
                    lineWrapping: true,
                    extraKeys: {'Ctrl-Space': 'autocomplete',
                            'F11'(cm) {
                                cm.setOption("fullScreen", !cm.getOption("fullScreen"))
                            },
                            'Esc'(cm) {
                            if (cm.getOption("fullScreen")) cm.setOption("fullScreen", false)
                        }
                    }
                },
                showedHtmlC : false,
                showedHtmlH : false,
                mycontent:  {
                    title: 'loading...',
                    assignment: 'loading...',
                    requestedFile: 'loading...',
                    authorsFile: 'loading...',
                    help: 'loading...',                   
                    rules_list: [] // settings of rules set in rulesList
                },
                HtmlContent: '',
                HtmlHelp: '',
                rulesListLang: null, // all rules in one language to cmb
                rulesGlobals: [], // id list of set rules
                HTMLSystemRules: null, // rules from sytem
                ruleSelectedIndex: -1
              }
    },
    props: ['ltype'],
    computed: 
            mapGetters([
                            'getLanguagePrimary',   
                            'getLanguageSecondary',
                            'getLanguagePrimaryTmp',   
                            'getLanguageSecondaryTmp',
                            'getRefresh1',
                            'getRefresh2',
                            'getChangedStore1',
                            'getChangedStore2',
                            'getAddElement',
                            'getCanDelete1',
                            'getCanDelete2',
                            'getSaveBeforeDelete1',
                            'getSaveBeforeDelete2',
                            'getDeleteElement',
                            'getRulesGlobals',
                            'getHTMLSystemRules',
                            'getContent11',
                            'getRuleIndex',
                            'getCollapses'
                        ])
    ,
    components: {
        quillEditor,
        codemirror
    },
    methods: {
        showHtmlC() {
            this.showedHtmlC = !this.showedHtmlC
            this.HtmlContent = this.mycontent.assignment
        },
        showHtmlH() {
            this.showedHtmlH = !this.showedHtmlH
            this.HtmlHelp = this.mycontent.help
        },
        updateC() {
            this.mycontent.assignment = this.HtmlContent
        },
        updateH() {
            this.mycontent.help = this.HtmlHelp
        },

       /************************************************************ */
        addAnswerEvent() {
            this.$store.commit('setRefresh1',true) // to save all content
            this.$store.commit('setRefresh2',true)            
            this.$store.commit('setAddElement',true)
        },
        addRule() {
            this.$store.commit('setAddElement',false)
            // and add rule to global lists
            this.$store.commit('addRuletoList11', {id : this.rulesListLang[this.ruleSelectedIndex].id, index: this.ruleSelectedIndex }) 
        },
        deleteRuleEvent(index) {
            this.$store.commit('setCanDelete1',false) 
            this.$store.commit('setCanDelete2',false)     
            this.$store.commit('setSaveBeforeDelete1',true) 
            this.$store.commit('setSaveBeforeDelete2',true)        
            this.$store.commit('setDeleteElement',index)
        },
        deleteRule() {
            var index = this.getDeleteElement
            this.$store.commit('setDeleteElement',-1)
            this.$store.dispatch('deleteRuleinList', index)           
        },
        /************************************************************ */
        saveActualContent(mylang) {   
            this.$store.commit('setRulesGlobals', this.rulesGlobals)

            var data = {
                lang_id : mylang.id,
                content: this.mycontent
            }
            this.$store.commit('setContent11', data)            
        },
        /************************************************************ */
        refreshData() {
            if (this.ltype =='1') {
                this.$store.commit('setRefresh1',false)
                if (this.getLanguagePrimaryTmp) 
                    this.saveActualContent(this.getLanguagePrimaryTmp)                
                this.$store.commit('setChangedStore1',true)
            } else {
                this.$store.commit('setRefresh2',false)
                if (this.getLanguageSecondaryTmp)
                    this.saveActualContent(this.getLanguageSecondaryTmp)
                this.$store.commit('setChangedStore2',true)            
            }            
        },
        /************************************************************/
        saveBeforeOperation() {
            if (this.ltype =='1') {
                this.$store.commit('setRefresh1',false)
                if (this.getLanguagePrimary) 
                    this.saveActualContent(this.getLanguagePrimary)
                this.$store.commit('setSaveBeforeDelete1',false) 
                this.$store.commit('setCanDelete1',true)
            } else {
                this.$store.commit('setRefresh2',false)
                if (this.getLanguageSecondary)
                    this.saveActualContent(this.getLanguageSecondary)
                this.$store.commit('setSaveBeforeDelete2',false) 
                this.$store.commit('setCanDelete2',true)
            }            
        },

        getContent11fromStore(lang_id) {
            return this.getContent11(lang_id)
        },
        readFromStore() {
            this.rulesGlobals = this.getRulesGlobals
            var con = null
            if (this.ltype == 1) {                
                this.$store.commit('setChangedStore1',false)
                con = this.getContent11fromStore(this.getLanguagePrimary.id)
                this.mycontent = con
            }
            if (this.ltype == 2) {                
                this.$store.commit('setChangedStore2',false)
                con = this.getContent11fromStore(this.getLanguageSecondary.id)
                this.mycontent = con
            }

            this.prepareRules()
        },
        //********************************************************************************************** */
        getEditorOption() {
          return {
                modules: {
                    'toolbar': [
                    [{ 'header': '1' }, { 'header': '2' }],
                    [ 'bold', 'italic', 'underline', 'strike' ],
                    ['code-block','blockquote',  { 'color': [] }, { 'background': [] }],
                    [{ 'script': 'super' }, { 'script': 'sub' }],
                    [{ 'list': 'ordered' }, { 'list': 'bullet'}, { 'indent': '-1' }, { 'indent': '+1' }],
                    [{ 'align': [] }],
                    [ 'link', 'image', 'formula' ],
                    [ 'clean' ]
                    ],
 /*                   syntax: {
                    highlight: text => hljs.highlightAuto(text).value
                    },
   */                 imageDrop: true,
                    imageResize: true
                },
                theme: 'snow'
            }
        },
        changeRuleIndex(index) {
            this.$store.commit('setRuleIndex', index)
            this.ruleSelectedIndex = index
        },
        prepareRules() {
            if (this.ltype == 1) {                
                this.rulesListLang = this.getHTMLSystemRules['l'+this.getLanguagePrimary.id]
            }
            if (this.ltype == 2) {                
                this.rulesListLang = this.getHTMLSystemRules['l'+this.getLanguageSecondary.id]
            }
        },
        isNumber: function(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                evt.preventDefault();
            } else {
                return true;
            }
        },

        checkCode() {
          this.executionInfo = ''  
          var _res = false
          this.executionResult = []  
          var correct = 0
          for(let i = 0; i < this.mycontent.rules_list.length; i++) {
              _res = check_rules.check_rule(this.mycontent.rules_list[i].rule_id, 
                                                              this.mycontent.rules_list[i].content, 
                                                              this.mycontent.authorsFile)
              if (_res) correct++             
              this.executionResult.push(
                  { res: _res,
                    desc : this.mycontent.rules_list[i].description
                  })

          }  
          this.grade = correct / this.mycontent.rules_list.length * 100
          this.showExecuteInfo = true
        },
        getResultColor() {
            if (this.grade == 0 && this.executionInfo == '') return 'primary'
            if (this.grade == 0) return 'red'
            if (this.grade == 100) return 'green'
            return 'orange'
        }
    }

}
</script>


<style>
</style>

